import React, { useState, useEffect } from "react";
import { Outlet, NavLink } from 'react-router-dom';
import { Box, List, ListItem, ListItemText, Typography, Paper, CircularProgress, Pagination, Tooltip, IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

export default function Mappings() {
    const [loading, setLoading] = useState(true);
    const [items, setItems] = useState({});
    const [page, setPage] = useState(1);

    /* >>>> API calls */
    async function getMappings(page = 1) {
        try {
            setLoading(true);
            const response = await fetch(`/api/mapping?page=${page}`, {
                method: 'GET',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' }
            });
            if (response.ok) {
                const data = await response.json();
                setItems(data);
            } else {
                setItems({});
            }
        } catch (error) {
            console.error('Error fetching mappings:', error);
            setItems({});
        } finally {
            setLoading(false);
        }
    }
    /* <<<< API calls */

    /* >>>> effects */
    useEffect(() => {
        getMappings();
    }, []);
    /* <<<< effects */

    const handlePageChange = (_, value) => {
        setPage(value);
        getMappings(value);
    }

    return (
        <Box display="flex" minHeight="100vh">
            <Paper style={{ width: 240, padding: 16 }}>
                <Box display="flex" alignItems="center" mb={2}>
                    <Typography variant="h6" ml={1}>
                        Mappings
                    </Typography>
                    <Tooltip title="Create New Mapping">
                        <IconButton color="primary" component={NavLink} to="new">
                            <AddIcon />
                        </IconButton>
                    </Tooltip>
                </Box>
                <div style={{ height: '75vh', overflowY: 'auto' }}>
                    {loading && <CircularProgress />}
                    {!loading && items.items?.length === 0 && (
                        <Typography variant="body1" color="textSecondary">
                            No mappings available.
                        </Typography>
                    )}
                    {!loading && items.items?.length > 0 && (
                        <List>
                            {items.items.map((item) => (
                                <ListItem
                                    button
                                    key={item.id}
                                    component={NavLink}
                                    to={`${item.id}`}
                                    style={({ isActive }) => ({
                                        backgroundColor: isActive ? '#f5f5f5' : 'transparent'
                                    })}
                                >
                                    <ListItemText primary={item.name} />
                                </ListItem>
                            ))}
                        </List>
                    )}
                </div>
                <Pagination page={page} count={items.totalPages} onChange={handlePageChange} style={{ margin: '20px auto', textAlign: 'center' }} />
            </Paper>
            <Box flex="1" padding={2}>
                <Outlet context={{ getMappings }}/>
            </Box>
        </Box>
    );
}
